const countriesData = [
  {
      "country": "South Africa",
      "millionaires": 37400,
      "centiMillionaires": 102,
      "billionaires": 5,
      "wealthGrowth": -20
  },
  {
      "country": "Egypt",
      "millionaires": 15600,
      "centiMillionaires": 52,
      "billionaires": 7,
      "wealthGrowth": -22
  },
  {
      "country": "Nigeria",
      "millionaires": 8200,
      "centiMillionaires": 23,
      "billionaires": 3,
      "wealthGrowth": -45
  },
  {
      "country": "Kenya",
      "millionaires": 7200,
      "centiMillionaires": 16,
      "billionaires": "",
      "wealthGrowth": 30
  },
  {
      "country": "Morocco",
      "millionaires": 6800,
      "centiMillionaires": 32,
      "billionaires": 4,
      "wealthGrowth": 35
  },
  {
      "country": "Mauritius",
      "millionaires": 5100,
      "centiMillionaires": 15,
      "billionaires": "",
      "wealthGrowth": 87
  },
  {
      "country": "Algeria",
      "millionaires": 2800,
      "centiMillionaires": 8,
      "billionaires": 1,
      "wealthGrowth": -28
  },
  {
      "country": "Ghana",
      "millionaires": 2700,
      "centiMillionaires": 6,
      "billionaires": "",
      "wealthGrowth": 26
  },
  {
      "country": "Ethiopia",
      "millionaires": 2700,
      "centiMillionaires": 4,
      "billionaires": "",
      "wealthGrowth": 30
  },
  {
      "country": "Namibia",
      "millionaires": 2300,
      "centiMillionaires": 3,
      "billionaires": "",
      "wealthGrowth": 32
  }
];

const totalData = [
    {
        "country": "Africa total",
        "millionaires": 135200,
        "centiMillionaires": 342,
        "billionaires": 21,
        "wealthGrowth": -8,
    }
];

export {countriesData, totalData};